import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Footer } from '../Footer/Footer'

import styles from './Layout.module.scss'
import { Avatar } from '@percent/lemonade'
import { LayoutProps } from './Layout.types'

export function Layout({ children, logo, programName }: LayoutProps) {
  const { t } = useTranslation()

  return (
    <div className={styles.outerContainer}>
      <div className={styles.brandedBackground} />
      <Outlet />
      <div className={styles.container}>
        {logo && (
          <div className={styles.logoWrapper}>
            <Avatar image={logo} size="xlarge" alt={programName ?? t('defaultLogoAlt')} />
          </div>
        )}
        {children}
        <Footer />
      </div>
    </div>
  )
}
